// Schema.org / internal-linking helpers. All URLs are absolute (origin-based).
export const SITE = typeof window !== "undefined" ? window.location.origin : "";
const ORG_NAME = "CollegeUnlock";
const ORG_DESC =
  "AI-powered college admission guidance — search colleges across India, compare options and get free counselling.";

export const courseSlug = (s) =>
  String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const titleCase = (slug) =>
  String(slug || "").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

export function organizationLd() {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: ORG_NAME,
    url: SITE,
    description: ORG_DESC,
  };
}

export function websiteLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: ORG_NAME,
    url: SITE,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

// items: [{ name, path }] — last item is the current page.
export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: SITE + it.path,
    })),
  };
}

export function collegeLd(c, path, image) {
  const ld = {
    "@context": "https://schema.org",
    "@type": "CollegeOrUniversity",
    name: c.College_Name,
    url: SITE + path,
    address: {
      "@type": "PostalAddress",
      addressLocality: c.City,
      addressRegion: c.State,
      addressCountry: "IN",
    },
  };
  if (image) ld.image = image;
  if (c.Official_Website) ld.sameAs = [c.Official_Website];
  return ld;
}

export function itemListLd(name, items) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      url: SITE + it.path,
    })),
  };
}

export function faqLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
